const getErrorMessage = (error: unknown): string => {
  return typeof error === 'string' ? error : (error as any).message;
};

export default getErrorMessage;
